import { render, staticRenderFns } from "./camodule.vue?vue&type=template&id=2d8f15f9&scoped=true"
import script from "./camodule.vue?vue&type=script&lang=js"
export * from "./camodule.vue?vue&type=script&lang=js"
import style0 from "./camodule.vue?vue&type=style&index=0&id=2d8f15f9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f15f9",
  null
  
)

export default component.exports